module.exports = __webpack_public_path__ + "img/caff3c5605c046c0faf1c9c388ca924c.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo9.png
// module id = 917
// module chunks = 5